import { Helmet } from "react-helmet";
import LinkButton from "./LinkButton";

export default function App() {
  return (
    <div className="fixed h-full w-full bg-[#09090b] flex flex-col items-center justify-center p-8">
      <Helmet>
        <title>ponchotang</title>
        <meta name="description" content="tools made by andy" />
      </Helmet>

      <div className="w-72">
        <p className="text-zinc-400 text-xs tracking-widest uppercase mb-8">ponchotang</p>
        <nav className="flex flex-col">
          <LinkButton to="/noise">noise generator</LinkButton>
          <LinkButton to="/clipboard">clipboard reader</LinkButton>
          <LinkButton to="/komachi">komachi reader</LinkButton>
          <LinkButton to="/medicine-tracker">medicine tracker</LinkButton>
          <LinkButton to="/generator">lofi generator</LinkButton>
          <LinkButton to="/about">about</LinkButton>
        </nav>
      </div>
    </div>
  );
}
